// 后台环境信息
const host = process.env.VUE_APP_EDU_HOST_URL
export default host



//////////////////
// WEBPACK FOOTER
// ./config/api.js
// module id = IYyn
// module chunks = 2